import React, {Component} from 'react';
import Main from '../Main';

class Reports extends Component{
    render(){
        return(
            <div>
                <Main/>
                <p>Reports</p>
            </div>
        )
    }
}

export default Reports;
